import React from 'react';
import styled from 'styled-components';

import SecurityFormHeader from './components/Header/SecurityFormHeader';
import TwoStepAuthentication from './components/TwoStepAuthentication/TwoStepAuthentication';

const SecurityForm = () => (
    <StyledSecurityForm>
        <SecurityFormHeader />
        <TwoStepAuthentication />
    </StyledSecurityForm>
);

export default SecurityForm;

const StyledSecurityForm = styled.section`
    margin-top: 64px;
`;
